import TopMarkets from 'app/shared/models/TopMarkets';
import assign from 'lodash/assign';
import constants from '../constants';

const initState = () => new TopMarkets();

const topMarkets = (state = initState(), action = {}) => {
  const { type, payload } = action;

  if (type === constants.SET_TOP_MARKETS) {
    return assign({}, state, payload);
  }
  return state;
};

export default topMarkets;
